import { Capacitor } from "@capacitor/core";

const KEY="mfsetu_client_pin_login_v2";
const USER_KEY="mfsetu_client_remembered_user_id";

export const isClientQuickAuthNative=()=>Capacitor.isNativePlatform();

export const saveRememberedUserId=(v)=>
  localStorage.setItem(USER_KEY,String(v||"").trim().toUpperCase());

export const getRememberedUserId=()=>localStorage.getItem(USER_KEY)||"";

export const clearRememberedUserId=()=>localStorage.removeItem(USER_KEY);

// The stored value is an opaque device credential + display metadata only.
// The 4-digit MPIN itself is NEVER stored on the device. The server requires
// both this credential and the user-entered MPIN before issuing a session.
export const hasPinCredential=async()=>{
  if(!isClientQuickAuthNative())return false;
  try{
    const v=JSON.parse(localStorage.getItem(KEY)||"null");
    return !!v?.deviceCredential;
  }catch{return false}
};

export const savePinCredential=async(v)=>{
  if(!isClientQuickAuthNative())return;
  const clean={
    deviceCredential:String(v?.deviceCredential||""),
    userId:String(v?.userId||"").trim().toUpperCase(),
    displayName:String(v?.displayName||""),
  };
  if(!clean.deviceCredential||!clean.userId)throw new Error("MPIN device binding is incomplete.");
  localStorage.setItem(KEY,JSON.stringify(clean));
  saveRememberedUserId(clean.userId);
};

export const readPinCredential=async()=>{
  if(!isClientQuickAuthNative())return null;
  try{
    const v=JSON.parse(localStorage.getItem(KEY)||"null");
    return v?.deviceCredential?v:null;
  }catch{return null}
};

export const clearPinCredential=async()=>{
  if(!isClientQuickAuthNative())return;
  localStorage.removeItem(KEY);
};
